import { ViewType } from 'devextreme/ui/scheduler';
import { EventType } from './calendar.types';
import React, { FC, useMemo, useState } from 'react';
import { FormComponentProps } from '../global-forms/GlobalForms.types';
import { EventTypeSelection } from './EventTypeSelection';
import { MeetingCreationForm } from './meeting/MeetingCreationForm';
import { VisitCreatingOrEditingForm } from '@lmt/unicorn-shared/app/components/calendar/visit/VisitCreatingOrEditingForm';

export const EventCreationForm: FC<
  FormComponentProps & {
    selectedInterval?: Interval;
    selectedEventType?: EventType;
    visitId?: number;
    assignedResources?: number[];
    patientId?: number;
    isWeekView?: boolean;
    caseId?: number;
    doctorId?: number;
    visitTypeId?: number | undefined | null;
    timeSlotTimeStepInMinutes?: number;
    calendarType?: ViewType;
    defaultVisitStartTimeInSeconds?: number;
  }
> = (props) => {
  const {
    formId,
    formType,
    tryCompleteForm,
    isExpanded,
    registerFormDirtyStateRetriever,
    selectedInterval,
    selectedEventType,
    expand,
    loadBlocking,
    closeForm,
    visitId,
    visitTypeId,
    assignedResources,
    patientId,
    isWeekView,
    caseId,
    doctorId,
    timeSlotTimeStepInMinutes,
    calendarType,
    defaultVisitStartTimeInSeconds,
    changeFormTitle,
    setIsCloseButtonHidden,
  } = props;

  const [eventType, setEventType] = useState<EventType>(
    selectedEventType || 'Visit',
  );

  const eventTypeSelection = useMemo(
    () =>
      !selectedEventType ? (
        <EventTypeSelection
          eventType={eventType}
          onEventTypeChanged={setEventType}
        />
      ) : null,
    [eventType, setEventType],
  );

  return eventType === 'Visit' ? (
    <VisitCreatingOrEditingForm
      selectedInterval={selectedInterval}
      formType={formType}
      formId={formId}
      isExpanded={isExpanded}
      tryCompleteForm={tryCompleteForm}
      closeForm={closeForm}
      registerFormDirtyStateRetriever={registerFormDirtyStateRetriever}
      expand={expand}
      eventTypeSelection={eventTypeSelection}
      loadBlocking={loadBlocking}
      visitId={visitId}
      visitTypeId={visitTypeId}
      caseId={caseId}
      assignedResources={assignedResources}
      patientId={patientId}
      doctorId={doctorId}
      isWeekView={isWeekView}
      timeSlotTimeStepInMinutes={timeSlotTimeStepInMinutes}
      calendarType={calendarType}
      defaultVisitStartTimeInSeconds={defaultVisitStartTimeInSeconds}
      changeFormTitle={changeFormTitle}
      setIsCloseButtonHidden={setIsCloseButtonHidden}
    />
  ) : (
    <MeetingCreationForm
      formType={formType}
      formId={formId}
      isExpanded={isExpanded}
      tryCompleteForm={tryCompleteForm}
      closeForm={closeForm}
      registerFormDirtyStateRetriever={registerFormDirtyStateRetriever}
      expand={expand}
      eventTypeSelection={eventTypeSelection}
      loadBlocking={loadBlocking}
      changeFormTitle={changeFormTitle}
      setIsCloseButtonHidden={setIsCloseButtonHidden}
    />
  );
};
